// extracted by mini-css-extract-plugin
export default {"title":"Patent_title__sWfP2","url":"Patent_url__cYIba"};